export var verticalLayoutScrollEventName = 'cg3:vertical-layout-scroll';
export var verticalLayoutScrollEvent = function (scrollTop) {
    return new CustomEvent(verticalLayoutScrollEventName, {
        cancelable: true,
        bubbles: true,
        detail: {
            scrollTop: scrollTop,
        },
    });
};
